// extracted by mini-css-extract-plugin
export default {"graphWrapper":"graph_graphWrapper__uOVR9"};